// src/components/events/EventsList.tsx
import { Stack, Box, CircularProgress, Alert } from '@mui/material';
import { EventCard } from './EventCard';
import { EventArticle } from '@/types/news.types';

interface EventsListProps {
  events: EventArticle[];
  loading?: boolean;
  error?: string | null;
  limit?: number;
  variant?: 'default' | 'modal';
  onClick?: (event: EventArticle) => void;
}

export const EventsList = ({ 
  events, 
  loading, 
  error, 
  limit, 
  variant = 'default',
  onClick 
}: EventsListProps) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" variant="outlined" sx={{ py: 2, textAlign: 'center' }}>
        {error}
      </Alert>
    );
  }

  const displayEvents = limit ? events.slice(0, limit) : events;

  if (displayEvents.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6 }}>
        <Alert severity="info">No hay eventos disponibles</Alert>
      </Box>
    );
  }

  return (
    <Stack
      sx={{
        display: variant === 'modal' ? 'flex' : { md: 'flex', sm: 'grid', xs: 'grid' },
        gap: 2,
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center' // Centers grid items horizontally
      }}
    >
      {displayEvents.map((event, index) => (
        <EventCard
        // event.id ||
          key={ index}
          event={event}
          variant={variant}
          onClick={() => onClick?.(event)}
        />
      ))}
    </Stack>
  );
};